<c-form-field [control]="control" [showErrors]="showValidation">
  @if (label) {
    <ion-label class="time-input__label">{{ label }}</ion-label>
  }

  <div class="time-input__box" cFieldBox>
    <!--
      Using one-way binding [value] instead of two-way binding [formControl] to prevent bypassing our
      custom formatting logic in onInputChange, and thus preventing emitting the mask as a value to the form.
      (preventing triggering valueChanges when the user just focuses or blurs the input without changing the value)
    -->
    <ion-input
      class="time-input__field"
      [value]="control?.value"
      [disabled]="control.disabled"
      inputmode="numeric"
      [clearInput]="showClearButton"
      [maskito]="maskitoOptions"
      [maskitoElement]="maskitoPredicate"
      [placeholder]="placeholder"
      [attr.data-test-id]="'time-input-component.input.ion-input'"
      (ionInput)="onInputChange($any($event.target).value)"
      (ionBlur)="onTouched()" />

    @if (icon) {
      <c-icon class="time-input__icon" [icon]="icon" />
    }
  </div>

  <c-field-message [helpText]="helpText" />
</c-form-field>
